var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"position-ab"},[(_vm.show)?[(_vm.isNoSillScore)?[_c('addSkiiScore',{ref:"addSkiiScore",attrs:{"packId":_vm.packId,"type":0}})]:[_c('skiiScoreList',{ref:"skiiScoreList"})]]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }